import React from "react";
import PropTypes from "prop-types";
import { CustomButton, CustomIconButton, icon } from "../../../../../common/components";
import styles from "./ThemeDrawerOption.module.css";
import { translate } from "../../../../../common/providers";

const ThemeDrawerOption = ({ open, onNewCommitment, onToggle }) => {
	const handleToggle = () => {
		onToggle();
	};

	return (
		<div className={styles.themeDrawerOption}>
			<CustomIconButton
				className={styles.drawer__iconBtn}
				icon={(open && icon.faChevronLeft) || icon.faBars}
				size="sm"
				variant="outlined"
				onClick={handleToggle}
			/>
			<CustomButton color="primary" startIcon={icon.faPlus} variant="outlined" onClick={onNewCommitment}>
				{translate("commitment-tracking.list.new-commitment")}
			</CustomButton>
		</div>
	);
};

ThemeDrawerOption.propTypes = {
	open: PropTypes.bool.isRequired,
	onToggle: PropTypes.func.isRequired,
};

export default ThemeDrawerOption;
